import { render, staticRenderFns } from "./CashSettlements.vue?vue&type=template&id=4ba61c84&scoped=true&"
import script from "./CashSettlements.vue?vue&type=script&lang=js&"
export * from "./CashSettlements.vue?vue&type=script&lang=js&"
import style0 from "./CashSettlements.vue?vue&type=style&index=0&id=4ba61c84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba61c84",
  null
  
)

export default component.exports